import { render, staticRenderFns } from "./Macro.vue?vue&type=template&id=953e0bb0&scoped=true&"
import script from "./Macro.vue?vue&type=script&lang=js&"
export * from "./Macro.vue?vue&type=script&lang=js&"
import style0 from "./Macro.vue?vue&type=style&index=0&id=953e0bb0&lang=scss&scoped=true&"
import style1 from "./Macro.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "953e0bb0",
  null
  
)

export default component.exports